module.exports = __webpack_public_path__ + "media/attack.718e0129.mp3";